// @flow weak

import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

const watchWindowSize = Component => {
  const WatchWindowSize = createReactClass({
    displayName: 'WatchWindowSize',

    getInitialState() {
      return {
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
      };
    },

    onResize() {
      this.setState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
      });
    },

    componentDidMount() {
      window.addEventListener('resize', this.onResize);
    },

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    },

    render() {
      return <Component {...this.props} {...this.state} />;
    },
  });

  return WatchWindowSize;
};

export default watchWindowSize;
